import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { setupIonicReact } from "@ionic/react";
import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "pymble-ui/theme.css";
import "pymble-ui/components.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { msal as msalConfig } from "./config";

setupIonicReact();

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
	const root = ReactDOM.createRoot(
		document.getElementById("root") as HTMLElement
	);
	root.render(<App msalInstance={msalInstance} />);
});
